let _navigate = null;
let _getLocation = null;

export function setNavigator(navigate, getLocation) {
    _navigate = navigate;
    _getLocation = getLocation;
}

export function push(to) {
    if (!_navigate) return;
    _navigate(to, { replace: false });
}

export function replace(to) {
    if (!_navigate) return;
    _navigate(to, { replace: true });
}

export function goBack() {
    if (_navigate) _navigate(-1);
}

export function getLocation() {
    return _getLocation ? _getLocation() : window.location;
}
